import { createAsyncThunk } from "@reduxjs/toolkit";
import { setCleanV2Open } from "../../cleanV2Slice";

export const closeCleanV2Thunk = createAsyncThunk(
  "clean/closeClean",
  (args, { dispatch }) => {
    dispatch(setCleanV2Open(false));
  },
);
